/**
 * Render the module background color based on cms selection
 * @param {string} color - the color selection
 * @returns {string}
 */
export const getModuleBackgroundColor = (color) => {
  switch (true) {
    case color === 'green':
      return 'module-background-color-green';
    case color === 'orange':
      return 'module-background-color-orange';
    case color === 'white':
      return 'module-background-color-white';
    case color === 'gray':
      return 'module-background-color-gray';
    case color === 'dark-gray':
      return 'module-background-color-dark-gray';
    case color === 'blue':
      return 'module-background-color-blue';
  }
};
